export default {
  // 模式
  "common.mode.auto": "自發自用",
  "common.mode.economy": "經濟模式",
  "common.mode.exigency": "應急模式",

  // 設備
  "common.grid": "電網",
  'common.evChargers': '充電樁',
  'common.evCharger': '充電樁',
  'common.pv': '光伏',
  'common.inverter': '逆變器',
  'common.pcs': '逆變器+電池',
  'common.terminal': '終端設備',
  'common.airc': '空調',
  'common.engine': '發動機',
  'common.battery': '電池',
  'common.metter': '電錶',
  'common.other': '其他',
  "common.power": "功率",
  "common.powerTotal": "總功率",
  "common.voltage": "電壓",
  "common.electricity": "電量",
  "common.current": "電流",
  "common.homeUsage": "家庭總負載",
  "common.battery.power": "電池功率",

  // 數據
  "common.noDataAvailable": '暫無數據哦~',
  'common.tips': '提示',
  "common.reset": "重置",
  "common.currencyUnit": '¥',
  "common.submiting": '正在提交，請稍候...',
  "common.close": '關閉',
  "common.from": '來自',
  "common.useIn": '用於',
  "common.energyPercent": '能量流佔比',
  "common.dataFlow": "數據流",
  "common.getDataIng": '正在獲取數據，請稍候...',
  "common.pageLoading": '頁面內容正在加載中，請稍候...',
  "common.reseting": "頁面內容重置，請稍候...",
  "common.save": '保存',
  "common.onlyNumberTips": "只能填寫數字",
  "common.offline": "離線",
  "common.online": "在線",
  "common.fault":"故障",
  "common.charge": "充電",
  "common.discharge": "放電",
  "common.buy": "買入",
  "common.sell": "賣出",
  "common.loadingInfo": '正在加載中，請稍候...',

  // 
  "common.moreFeatures": "更多功能",
  "common.confirm": '確認',
  "common.saveing": "正在保存中，請稍候...",
  "common.searchPlacholder": "請輸入搜索關鍵字",
  "common.iSee": '我知道了',
  "common.pageErrorTips1": "哎呀，網頁出錯啦~",
  "common.pageErrorTips2": "請嘗試刷新一下,或聯繫客服~",
  "common.refresh": "刷新",
  "common.backToHome": "回到首頁",
  "common.checkTips": "正在校驗，請稍候...",
  "common.back": "返回",
  "common.cancel": "取消",
  "common.optional": "選填",
  "common.required": "必填",
  "common.status": "狀態",
  "common.statusNoDelete": "未刪除",
  "common.statusDelete": "已刪除",
  "common.submit": '提交',
  "common.disable": "停用",
  "common.enable": "啟用",
  "common.year": '年',
  "common.month": '月',
  "common.day": '日',
  "common.version": '版本號：',
  "common.backHome": ' 返回首頁',
  "common.backHomeSorry": ' 很抱歉，頁面不小心迷路了',
  "common.requestTips1": '數據正在處理，請勿重複提交',
  "common.requestTips2": "系統提示",
  "common.requestTips3": "登錄狀態已過期，請重新登錄",
  "common.requestTips4": "重新登錄",
  "common.requestTips5": "無效的會話，或者會話已過期，請重新登錄。",
  "common.requestTips6": "服務器異常，請稍後再試。",
  "common.requestTips7": "系統接口請求超時",
  "common.requestTips8": '系統接口',
  "common.requestTips9": '異常',
  "common.iknow": '我知道了',
  "common.logoutSuccess": "退出成功",
  
  // 了解更多組件
  "common.knowMore.title": '想了解更多，請聯繫北能',
  "common.knowMore.email": '聯繫郵箱',
  "common.knowMore.phone": '聯繫電話',
  "common.knowMore.wechat": '聯繫微信',
  "common.knowMore.website": '官網地址',
  "common.knowMore.address": '聯繫地址',
  "common.knowMore.addressDetail": '廣東省東莞市黃江鎮黃京坑清河路8號5棟1205室、1301室',
  
  // 本地連接組件
  "common.localConnection": '本地連接',
  "common.operateInApp": '請在APP中操作!',
  
  "common.enbleStaus": "啟用狀態",
  "common.battery.status": "不充不放",

  'account.forgetThePassword': '忘記密碼',
    'account.logInDirectly': '直接去登錄',
    'account.tips1': '頁面正在跳轉，請稍候...',
    'account.tips2': '請先查看並同意用戶須知！',
    'account.autoLogin': '自動登錄',
    'account.userLogin': '用戶登錄',
    'account.registerTips': '還沒有賬號？點擊這裡去註冊',
    'account.userEmail': '用戶名/郵箱',
    'account.userEmailTips': '請輸入用戶名/郵箱',
    'account.password': '密碼',
    'account.passwordTips': '請輸入密碼',
    'account.submit': '提交',
    'account.submitTips': '提交中,請稍候...',
    'account.otherLoginTips': '或選擇其他登錄方式',
    'account.userRegistration': '用戶註冊',
    'account.userName': '用戶名',
    'account.userNameTips': '請輸入用戶名',
    'account.emailTips1': '請輸入郵箱地址',
    'account.emailTips2': '郵箱地址格式不正確',
    'account.phone': '電話號碼',
    'account.phoneTips1': '請輸入電話號碼',
    'account.phoneTips2': '電話號碼不正確',
    'account.phoneTips3': '請輸入電話號碼',
    'account.passwordTips1': '請輸入6-30位密碼',
    'account.passwordTips2': '密碼格式不對，密碼由英文數字和下劃線橫線點號自由組成, 長度6-12位',
    'account.passwordTips3': '兩次輸入密碼不一致，請檢查並重新輸入！',
    'account.passwordTips4': '請輸入密碼, 密碼由英文數字和下劃線橫線點號自由組成',
    'account.passwordTips5': '確認密碼',
    'account.passwordTips6': '請輸入確認密碼',
    'account.passwordTips7': '兩次輸入密碼不一致，請檢查並重新輸入！',
    'account.passwordTips8': '請輸入確認密碼',
    'account.passwordTips9': '恭喜您註冊成功！',
    'account.passwordTips10': '您的用戶名是：',
    'account.emailIs': '郵箱是：',
    'account.goToLoginPage': 's後將自動跳轉到登錄頁面',
    'account.goLogin': '去登錄',
    'account.goRegister': '註冊',
    'account.loginSuccess': '登錄成功',
    'account.email': '郵箱',
    'account.sologn': '用心打造專屬於您的能源方案',
    'account.pleaseAgree': '我已閱讀並同意',
    'userAgreement.privacyPolicy': '隱私政策',

    "account.code": "驗證碼",
    "account.codeTips": "請輸入驗證碼",
    "account.codeTips2": "驗證碼不正確",

    "account.inviteCodeTips": "請輸入邀請碼",
    "account.inviteCodeHint": "請聯繫安裝工或運維人員獲取邀請碼",
    "account.modifyPasswordByAccount": "賬號修改密碼",
    "account.modifyPasswordByEmail": "郵箱修改密碼",
    "account.getPasswordByAccount": "賬號找回密碼",
    "account.getPasswordByEmail": "郵箱找回密碼",

    "account.sendEmailTips": "驗證碼已發送到郵箱, 請去郵箱查收",
    "account.name": "賬號名",
    "account.newPassword": "新密碼",
    "account.confirmNewPassword": "確認新密碼",
    "account.nameTips": "請輸入賬號名",
    "account.passwordModifySuccess": "密碼修改成功",
    "account.emailCode": "郵箱驗證碼",
    "account.emailCodeTips": "請輸入郵箱驗證碼",
    "account.emailCodeTips2": "郵箱驗證碼不正確",
    "account.emailModifySuccess": "密碼修改成功",
    "account.passworTips1": "您密碼已重置成功！",
    "account.passwordTips11": "請輸入確認密碼",
    "account.passwordTips12": "請輸入新密碼",
    "account.nickname": "用戶暱稱",
    "account.modifyNickname": "修改用戶暱稱",
    "account.modifyNicknameSuccess": "用戶暱稱修改成功!",
    "account.nicknameTips": "請輸入用戶暱稱",
    'account.nicknameError': '用戶暱稱修改失敗！',

    "account.login": '登入',
    'account.quickRegister': '快速註冊',
    'account.sendCode': '發送驗證碼',
    'account.sendTips': 's後可重發',
    "account.sendEmailIng": '正在發送郵件，請稍候...',
    'account.emailNotEmpty': '郵箱地址不能為空',
    'account.registerAccount': '註冊賬號',
    'account.registerWelcome': '歡迎註冊 SusprSafe',
    'account.usernameLimit': '用戶名只能以字母開頭，且只能包含字母、數字、下劃線，長度在5-15位之間',

    'copyright.desc2': '網站備案信息：粵ICP備2021169764號',

    'editUserInfo.editUserInformation': '編輯用戶信息',
    'editUserInfo.modifyUsername': '修改用戶名',
    'editUserInfo.changePictures': '修改頭像',
    'editUserInfo.savePicturesSuccess': '用戶頭像保存成功',
    'editUserInfo.saveError': '保存失敗',
    'editUserInfo.pictureLimit':'圖片必須小於2M',
    'editUserInfo.uploadPicture':'上傳頭像',
    'editUserInfo.picturePreview':'預覽',
    
    'editUserInfo.bindPhoneNumber': '綁定電話號碼',
    'editUserInfo.bindEmail': '郵箱綁定',
    'editUserInfo.changePassword': '密碼修改',

    'editUserInfo.notificationSettings': '通知設置',
    'editUserInfo.editAccount': '編輯用戶賬號信息',
    'editUserInfo.waitBingting': '正在綁定中，請稍候...',
    'editUserInfo.collapse': '收起',
    'editUserInfo.modifyBinding': '修改綁定',
    
    'editUserInfo.emailAddress': '郵箱地址',
    'editUserInfo.tips1': '郵箱綁定成功',
    'editUserInfo.tips2': '保存失敗',
    'editUserInfo.tips3': '正在發送郵箱驗證碼，請稍候...',
    'editUserInfo.tips4': '驗證碼已經發送到郵箱xxxx，請查收',
    'editUserInfo.tips5': '驗證碼發送失敗！',
    'editUserInfo.tips6': '已經綁定手機號',
    'editUserInfo.tips7': '已經綁定郵箱',
    'editUserInfo.emailTips1': '請輸入郵箱地址',
    'editUserInfo.emailTips2': '郵箱地址格式不正確',
    'editUserInfo.emailTips3': 'xxxxs後可重發',
    'editUserInfo.emailTips4': '發送驗證碼',
    'editUserInfo.emailTips5': '郵箱驗證碼不能為空',
    'editUserInfo.emailTips6': '郵箱驗證碼不正確',
    'editUserInfo.emailCode': '郵箱驗證碼',
    'editUserInfo.save': '保存',

    'editUserInfo.phoneTips1': '手機號碼綁定成功',
    'editUserInfo.phoneTips2': '正在發送手機驗證碼，請稍候...',
    'editUserInfo.phoneTips3': '短信驗證碼已經發送到手機xxxx，請查收',
    'editUserInfo.phoneTips4': '短信驗證碼發送失敗！',
    'editUserInfo.phoneTips5': '請輸入電話號碼',
    'editUserInfo.phoneTips6': '電話號碼格式不正確',
    'editUserInfo.phoneTips7': '發送短信驗證碼',
    'editUserInfo.phoneTips8': '短信驗證碼',
    'editUserInfo.phoneTips9': '手機驗證碼不能為空',
    'editUserInfo.phoneTips10': '手機驗證碼不正確',
    'editUserInfo.phone': '電話號碼',


    'editUserInfo.noticeTips1': '獲取通知配置失敗！',
    'editUserInfo.noticeTips2': '通知設置保存成功!',
    'editUserInfo.noticeTips3': '電池電量低通知',
    'editUserInfo.noticeTips4': '充電樁完成通電通知',
    'editUserInfo.errorNotification': '報錯通知',
    'editUserInfo.updateNotification': '升級更新通知',
    'editUserInfo.monthlyStatisticsNotification': '月度統計通知',
    'editUserInfo.notificationMethod': '接收方式',

    'editUserInfo.userNameTips1': '用戶名保存成功',
    'editUserInfo.userNameTips2': '用戶名保存失敗',
    'editUserInfo.userNameTips3': '請輸入用戶名',
    'editUserInfo.userNameTips4': '用戶名格式不正確，必須數字下劃線英文組成',
    'editUserInfo.userNameTips5': '請輸入用戶名',
    'editUserInfo.userNameTips6': '正在保存，請稍候...',
    'editUserInfo.userName': '用戶名',

    'editUserInfo.avatorTips': '點擊修改頭像',
    'editUserInfo.verifyCodeTips1': '請輸入您收到的驗證碼：',
    'editUserInfo.verifyCodeTips2': '為了您的賬號安全，請點擊以下按鈕給原手機號發送驗證碼：',
    'editUserInfo.verifyCodeTips3': '發送驗證碼',
    'editUserInfo.verifyCodeTips4': '原手機驗證通過，請輸入新的綁定手機號',
    'editUserInfo.verifyCodeTips5': '為了您的賬號安全，請點擊以下按鈕給原郵箱發送驗證碼：',
    'editUserInfo.verifyCodeTips6': '原郵箱驗證通過，請輸入新的郵箱',
    'editUserInfo.verifyCodeTips7': '舊密碼',
    'editUserInfo.verifyCodeTips8': '請先綁定郵箱！',
    'editUserInfo.verifyCodeTips9': '驗證碼已發送到郵箱, 請去郵箱查收',
    "editUserInfo.verifyCodeTips10": '，將自動跳轉到登錄頁面',

    "hems.notice.title": "通知標題", 
   "hems.notice.content": "通知內容", 
   "hems.notice.operate": "操作",
   "hems.notice.noRead": "未讀",
   "hems.notice.read": "已讀",
   "hems.notice.warning": "提醒",
   "hems.notice.error": "異常",
   "hems.notice.success": "統計結算",
   "hems.notice.sys": "系統信息",
   "hems.notice.operateSuccess": "操作成功",
   "hems.notice.operateTips": "請選擇要操作的項",

    // 首頁
   "hems.home.selfuseRate": "自發自用率",
   "hems.home.percent": "百分比",
   "hems.home.todayData": "今日數據",
   "hems.home.todayPowerGeneration": "今日發電量",
   "hems.home.salesIncome": "賣電收益",
   "hems.home.saved": "已為你節省",
   "hems.home.reduce": "減少碳足跡",
   "hems.home.tips1": "暫無數據，您還沒綁定xxxx",
   "hems.home.criticalLoad": "關鍵負載",
   "hems.home.keyVoltage": "關鍵電壓",
   "hems.home.householdLoad": "家庭負載",
   "hems.home.householdVoltage": "家庭電壓",
   "hems.home.generalLoad": "普通負載",
   "hems.home.generalVoltage": "普通電壓",
   "hems.home.batteryHealth": "電池健康度",
   "hems.home.averageTemp": "平均溫度",
   "hems.home.gridLoad": "電網負荷",
   "hems.home.toggeleDataSource": "當前展示數據已切換為:",
   "hems.home.toggleTips": "您確定要更換嗎？",
   "hems.home.modeSending": "模式指令正在發送中，請稍候...",
   "hems.home.modeSuccess": "模式切換指令已成功發送！",
   "hems.home.isOnline": "是否在線",
   "hems.home.useStatus": "使用狀態",
   "hems.home.workModeText": '當前工作模式：',
   "hems.home.toggleDataSourceText": '當前展示數據已切換為：',
   "hems.ev.charge.status": "充電狀態",
   "hems.ev.charge.time": "充電時長",
   "hems.ev.charge.count": "實時充電量",
   "hems.ev.charge.status.empty":"空閒",
   "hems.ev.charge.status.ing":"插槍充電中",
   "hems.ev.charge.status.null":"插槍未充電",
   "hems.ev.charge.status.error":"故障",
   "hems.hour":"小時",
   "hems.minue":"分鐘",
   "hems.ev.chagre.number": "充電樁編號",

   // User Guide
   "hems.userGuide.selfUse": "自發自用",
   "hems.userGuide.selfUseTips": "優先使用光伏發電，不足時從電網補充",
   "hems.userGuide.economyMode": "經濟模式",
   "hems.userGuide.economyModeTips": "根據電價優化用電策略",
   "hems.userGuide.emergencyMode": "應急模式",
   "hems.userGuide.emergencyModeTips": "優先保證關鍵負載供電",

   // 圖表頁面
   "hems.history.energyStatistics": "能量統計",
   "hems.history.revenueStatistics": "收益統計",
   "hems.history.greenStatistics": "綠色減排",
   "hems.history.revenueTitle": "賣電總收益",
   "hems.history.savingsTitle": "總節省",
   "hems.history.carbonTitle": "總減少碳排放",
   "hems.history.day": "日",
   "hems.history.month": "月",
   "hems.history.year": "年",
   "hems.history.beforeDay": "前一天",
   "hems.history.afterDay": "後一天",
   "hems.history.beforeMonth": "上一月",
   "hems.history.afterMonth": "後一月",
   "hems.history.beforeYear": "上一年",
   "hems.history.afterYear": "後一年",
   "hems.history.totalUse": '總計使用',
   "hems.history.fullScreen": '全屏',
   "hems.history.timeSelect": "日期選擇",
   "sync.tips1": "同步數據指令已經發送成功！",
   "sync.tips2":"數據同步在進行中，因數據量比較大，同步過程需要一點時間，請半個小時後再來查看~",
   "sync.tips3": "設備同步數據有可能延遲，如發現數據異常，請點擊：",
   "sync.tips4": "同步數據",

   "charge.info": "充電樁信息",
   "news.loading": '加載中...',
   "news.noMore": '沒有更多了',
   "hems.pv.power": '光伏供電量',

  // UEH specific
  "ueh.sellPower": "賣電量",
  
   "menu.home": "首頁",
   "menu.history": "歷史數據",
   "menu.device": "設備",
   "menu.settings": "設置",
   "menu.messageCenter": "消息中心",
   "menu.help": "幫助與支持",
   "menu.mine": "我的",


  "mine.userSetting": "用戶設置",
  "mine.terminalSetting": "終端基礎設置",
  "mine.uploadCloud": "數據上雲備份",
  "mine.changeVersion": "檢查更新",
  "mine.language": "切換語言",
  "mine.about": "關於",
  "mine.feedback": "意見與反饋",
  "mine.logout": "退出登錄",
  "mine.logoutAccount": "註銷賬號",

  "mine.logoutAccountTips": "註銷名字為[]的賬號",
  "mine.logoutAccountTips1": "註銷[]綁定的賬號",
  "mine.logoutAccountCare": "申請註銷的關聯事項：",
  "mine.logoutAccountCare1": "1. 賬號處於安全狀態",
  "mine.logoutAccountCare1-1": "賬號當前為正常使用狀態，不存在被盜、違規、禁用等風險。",
  "mine.logoutAccountCare2": "2. 賬號授權、綁定關係已解除",
  "mine.logoutAccountCare2-1": "賬號已解除與其他第三方平台的授權等。",
  "mine.logoutAccountCare3": "3. 賬號註銷後不可找回，用戶數據均清除",
  "mine.logoutAccountCare3-1": "註銷賬號後，綁定的手機以及郵箱等賬號以及相關數據，均被清除不可找回。",
  "mine.confirmLogout": "確認註銷",
  "mine.logoutSuccess": "賬號刪除成功！",

  "mine.feedbackIssues": "反饋問題",
  "mine.feedQuantity": "數量",
  "mine.feedAmount": "上限9張圖片，最大1MB/張",

  "mine.notice.fail": "獲取通知配置失敗！",
  "mine.notice.saveSuccess": "通知設置保存成功！",
  "mine.notice.saveFail": "保存失敗！",
  "mine.notice.title": "通知設置",
  "mine.notice.batteryLow": "電池電量低通知",
  "mine.notice.chargingFinish": "充電樁充電完成通知",
  "mine.notice.error": "報錯通知",
  "mine.notice.update": "升級更新通知",
  "mine.notice.monthly": "月度統計通知",
  "mine.notice.receiveType": "接收方式",

  "mine.language.welcome": "歡迎使用SusprSafe",
  "mine.language.desc1": "請依據你所在的地區設置語言版本",
  "mine.language.desc2": "你可以隨時通過應用程序的設置進行更改",

  "mine.userInfo.avatar":"頭像",
  "mine.userInfo.nickname":"暱稱",
  "mine.userInfo.password":"密碼",
  "mine.userInfo.changePassword":"修改密碼",
  "mine.userInfo.setPassword":"設置密碼",
  "mine.userInfo.phoneNumber":"電話號碼",
  "mine.userInfo.bindPhone":"綁定電話號碼",
  "mine.userInfo.bindEmail":"綁定郵箱",
  "mine.loginExpired":"登錄過期，請重新登錄",
  "mine.userInfo.title":"用戶信息",
  "mine.userInfo.bind":"綁定",
  "mine.userInfo.modify": "修改",
  "mine.userInfo.modifyNickname":"修改暱稱",
  "mine.userInfo.userNickname":"用戶暱稱",
  "mine.userInfo.selectPic":"請選擇上傳的圖片",
  "mine.userInfo.saveSuccess":"保存成功",
  "mine.userInfo.uploadFail":"上傳失敗",
  "mine.userInfo.avatarSaveSuccess":"頭像保存成功",
  "mine.userInfo.nameTips1":"用戶暱稱不能為空",
  "mine.userInfo.nameTips2":"請輸入用戶暱稱",

  "common.pleaseSelect": "請選擇",
  "question.commonQuestions": "常見問題",
  "account.toggleLanguage": '切換語言',
  "account.localConnection": "本地連接",
  "account.selectLanguage": '請選擇語言',
  "account.sendEmailToast": "驗証碼已髮送到郵箱xxx, 請去郵箱查收",
  "account.emailError": "郵箱格式不正確",
  "account.sendEmailFail": "髮送失敗，請重試",
  
  "common.submitting": "正在提交中， 請稍候...",
  "device.page.noData": "暫無數據, 此頁麵需在app中才能預覽"
,

  // OTA 升級
  "bmsFirmware.upgrade": "升級",
  "bmsFirmware.upgrading": "升級中...",
  "bmsFirmware.uploadingFile": "正在上傳韌體檔案...",
  "bmsFirmware.upgradingProgress": "正在升級韌體... {progress}%",
  "bmsFirmware.upgradeSuccess": "升級成功",
  "bmsFirmware.upgradeSuccessSubtitle": "BMS韌體升級完成！",
  "bmsFirmware.upgradeFailed": "升級失敗",
  "bmsFirmware.upgradeFailedFormError": "請檢查表單填寫是否正確",
  "bmsFirmware.upgradeFailedNetworkError": "網路異常，請重試",
  "bmsFirmware.invalidFileType": "請選擇有效的韌體檔案 (.bin, .hex, .fw, .firmware)",
  "bmsFirmware.selectFileWarning": "請先選擇韌體檔案",
  "bmsFirmware.statusUpgrading": "升級中",
  "bmsFirmware.statusCompleted": "升級完成",
  "bmsFirmware.statusFailed": "升級失敗",
  "bmsFirmware.deviceUpgrading": "正在升級韌體包，升級時間在30 ~ 50 分鐘，期間無法查看設備即時數據，請等待...",
  "bmsFirmware.upgradeStatusLabel": "升級狀態",
  "bmsFirmware.upgradeProgressLabel": "升級進度",
  "bmsFirmware.currentPackageLabel": "當前已傳輸的數據包序號",
  "bmsFirmware.totalPackagesLabel": "總數據包數量",
  "bmsFirmware.upgradeFailedCheckDevice": "請檢查設備狀態，並重新嘗試升級",

  // 設置結果彈窗相關翻譯
  "settingResult.defaultTitle": "設置成功",
  "settingResult.defaultSubTitle": "參數設置已保存",
  "settingResult.confirmButton": "確定"
};